import { useState } from "react";
import { toast } from "sonner";
import { BarChart3, Trash2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toLocalInput, fromLocalInput } from "@/lib/calendar";

const F = [["copertura", "Copertura"], ["like", "Like"], ["commenti", "Commenti"], ["salvataggi", "Salvataggi"], ["condivisioni", "Condivisioni"], ["visualizzazioni", "Visualizzazioni"]];

const ChannelForm = ({ post, canale, current, onSaved }) => {
  const [f, setF] = useState(() => ({ pubblicato_il: toLocalInput(current?.pubblicato_il || post.data_pubblicazione), ...Object.fromEntries(F.map(([k]) => [k, current?.[k] ?? ""])) }));
  const save = async () => {
    try {
      const body = { canale, pubblicato_il: fromLocalInput(f.pubblicato_il), ...Object.fromEntries(F.map(([k]) => [k, Number(f[k]) || 0])) };
      onSaved((await api.put(`/admin-ai/posts/${post.id}/metriche`, body)).data.metriche); toast.success("Metriche salvate");
    } catch (e) { toast.error(errMsg(e)); }
  };
  const remove = async () => { try { onSaved((await api.delete(`/admin-ai/posts/${post.id}/metriche/${canale}`)).data.metriche); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <div className="rounded-xl border border-slate-200 p-3" data-testid={`metrics-${canale}`}>
      <div className="flex items-center justify-between"><b className="capitalize text-sm">{canale}</b>{current?.er != null && <span className="text-xs font-bold text-emerald-700" data-testid={`metrics-er-${canale}`}>ER {current.er}%</span>}</div>
      <label className="mt-2 block text-[11px] font-bold text-slate-500">Data/ora effettiva<Input type="datetime-local" value={f.pubblicato_il} onChange={(e) => setF({ ...f, pubblicato_il: e.target.value })} className="mt-0.5 rounded-lg" data-testid={`metrics-${canale}-data`} /></label>
      <div className="mt-2 grid grid-cols-2 sm:grid-cols-3 gap-2">
        {F.map(([k, l]) => <label key={k} className="text-[11px] font-bold text-slate-500">{l}<Input type="number" min={0} value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} className="mt-0.5 rounded-lg" data-testid={`metrics-${canale}-${k}`} /></label>)}
      </div>
      <div className="mt-2 flex gap-2">
        <Button type="button" size="sm" onClick={save} className="rounded-full bg-[#0A1128] font-bold" data-testid={`metrics-${canale}-save`}>Salva</Button>
        {current && <Button type="button" size="sm" variant="ghost" onClick={remove} className="rounded-full text-[#E8173A]" data-testid={`metrics-${canale}-delete`}><Trash2 className="h-4 w-4" /></Button>}
      </div>
    </div>
  );
};

export const PostMetrics = ({ post, onChange }) => {
  const [m, setM] = useState(post.metriche || []);
  const saved = (list) => { setM(list); onChange?.({ ...post, metriche: list }); };
  return (
    <details className="rounded-xl border border-[#5FB3EA] bg-[#A6DAFC]/40 p-3" data-testid="post-metrics">
      <summary className="cursor-pointer text-sm font-bold text-[#0A1128]"><BarChart3 className="inline h-4 w-4 mr-1 text-[#E8173A]" />Metriche (solo admin){m.length ? ` · ${m.length} canali` : ""}</summary>
      <div className="mt-2 space-y-2">{(post.canali || []).map((c) => <ChannelForm key={c} post={post} canale={c} current={m.find((x) => x.canale === c)} onSaved={saved} />)}</div>
    </details>
  );
};
